
import {Spinner} from 'react-bootstrap'
import { useSpinLoadStore } from '../../store/useSpinLoadStore';

export const SpinerLoad = (props) => {

    const {SpinLoad} = useSpinLoadStore();
    return (
       <> 
       {
        SpinLoad ?
            <div id="SpinerLoad" className="SpinLoadPadre  ">
            <div className="SpinLoadhijo">
            <Spinner className="SpinLoad-centered" style={{ width: '12rem', height: '12rem' }} type="grow"  animation="grow" />
            </div>         
        </div> : ""
        }
       </>
      
    )
}